export default __webpack_public_path__ + "static/sports-bar-c35b67efa0ec516eb0af4e7b10a10216.jpg";